
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helpBMXUzVwJ1Sh_45syr6mZavTM5x_A8ZTsSJk_gMFOWNkT8Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/help.vue?macro=true";
import { default as indexCWUPTmnntzJVCrvbb91u5ZhaIIQfde7P5KDjAF8vZXMMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/index.vue?macro=true";
import { default as loginZY81Li9kRUYcO_45ZMVeUNW1Gt5Cdf79hhw1zQXO_45P2nIMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/login.vue?macro=true";
import { default as logoutbgVLGDCMiSUF3inGTrB7MbTv6Je_TlDOczk_45TVryjTQMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/logout.vue?macro=true";
import { default as privacyoPZxU3LcIk55WyLWwgKkVovH2wEDMXggc6oVDkxIoUgMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/privacy.vue?macro=true";
import { default as newWo3cZb0UgpsrHzwhe9OAAXL4ldRN53ulUYXSSLSWfK4Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie/new.vue?macro=true";
import { default as indexKrtqz_45p_45xWrqeHle9KJY711sEIXTAFv4HCMWv8Idu6cMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie/index.vue?macro=true";
import { default as editUiCTkKwcuEvq5BtXpXowhGUNa79CE2v_45fx_HSSobsAUMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie/[rieId]/edit.vue?macro=true";
import { default as indexBKLJ5CgIJVAYHTJNtJX3Q4UdWQJC__S7AtzOcHr_sokMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie/[rieId]/index.vue?macro=true";
import { default as rieJt5rxvpqlY4cHVOa3jpPlW_45_pAQcFC8lxils5g6fJ0sMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie.vue?macro=true";
import { default as indexiInSGaZkteFjW62YBBcqoaBz0BoCeJ59EM1UShgnBPMMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/index.vue?macro=true";
import { default as indexk5krPrPi_Xfcm_45aQImUR7BkN6e8pBBFvJ3QK3MvbIawMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/risicos/index.vue?macro=true";
import { default as editEfxevWEeCvG4x59xX1_GSu9ObajSxMcbrJ2CBnUrG6QMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/edit.vue?macro=true";
import { default as index_45_VCHVZfUP5XBQbzc7K9FjWBfPf9kDgdThE26flqQegMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/index.vue?macro=true";
import { default as risicosQ05J51W5PzrSqo9r_45hMNa98hOHh2fNzmPiLiyTb_45G_IMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/risicos.vue?macro=true";
import { default as dashboardfcoXFtsbncQDZj8p__45oPZLHxYqqlBOK7DV_rKmbfxpYMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/dashboard.vue?macro=true";
import { default as index0aUCjajHFxmmmw79fFH_455QxtdfJRsulnB518VIcVR68Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/rapportage/index.vue?macro=true";
import { default as aanmakenwXZSyMpRPOEp5VUM7UxN2TzWnEsPqMfjUrXjUew2YpUMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/rapportage/aanmaken.vue?macro=true";
import { default as rapportageJRrkliNTLWfTk62fS9CLavsSALAy98Ex5cWa9esV0jEMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/rapportage.vue?macro=true";
import { default as indexKgOntLY_45zuE5KAh3T5EM62nb7_45pYR5O0_45Xek3d49BnAMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/index.vue?macro=true";
import { default as onderwerpenZXk0Ilq9M4cirCDEh3Q1Xt7o99JfiSlIiY_0yPAY3LkMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/onderwerpen.vue?macro=true";
import { default as endwWV_45y9KPFLi6NJ7U_ZiYvxaeiM8NrOwZ6Yl8evhcqzsMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/end.vue?macro=true";
import { default as indexAIhJKU8g3HQ7WEoH8VDmwj_45YqSxCRtWQ28_45qJiym9qsMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/index.vue?macro=true";
import { default as _91questionKey_93iUVwEI2XAm6DYZI00RtouTImw2eqKEcD7gm1znlcVa8Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/[questionKey].vue?macro=true";
import { default as inventarisatieFGNLr9sfI8H4kXEZT7y5CgYvxW2O6bwkk6BR45Gd3B0Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie.vue?macro=true";
import { default as index8_5IKtH5XZiqirEDRgZMMTKIS7D9wqovbC33Wj70PcgMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/index.vue?macro=true";
import { default as editl6aHvvg_IOV4uiT7iD0diHpquPUh_45v6T9yHEhlYwvaIMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/edit.vue?macro=true";
import { default as indexC6n9i5tO4ptS_VQaS8V_45N0_45Ry3mLWDddoLsBl9W6ia0Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/index.vue?macro=true";
import { default as plan_45van_45aanpakEjr8CMyTHPCgqIzhxCp35EWMy88FymUrVdOYF0IBXWIMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/plan-van-aanpak.vue?macro=true";
import { default as indexIIbjB2QYgvX0oE7MDI6IdPofog4DA1apnj4c7V66kzIMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/stigas/werknemersvragenlijst/index.vue?macro=true";
import { default as _91rieId_93a4R10rXVgpuzcrJnrFqTNi3ECV5vKrjO6hnHANmd5UUMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId].vue?macro=true";
import { default as index_uVds1HPwW0LAD8dfn3hoTijR4TmrRtFwg9TMR_45iBu0Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/gebruikers/index.vue?macro=true";
import { default as _91userId_931XfMkABcobM3aVFfT5IgH6U0pka8MJI1UwZw0L9VKFUMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/gebruikers/[userId].vue?macro=true";
import { default as uitnodigeno2UiWBu2ngbC1zBIIXSuvfrG7znRsLc4IcGw6tNrUIMMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/gebruikers/uitnodigen.vue?macro=true";
import { default as gebruikersH69QcoDW6n4rsquVPfPSo25glJf3eQq7c2IBIjCyQ6IMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/gebruikers.vue?macro=true";
import { default as editXwy99iCGOLMKLu_45o1JXpY1Cnr3PRX_A4e0dkHhLltV4Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/bedrijfsinformatie/edit.vue?macro=true";
import { default as indexQD55RlJJB6ucYu6bjS_45rsxHphWKyDgcHd4OV_452qFVIwMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/bedrijfsinformatie/index.vue?macro=true";
import { default as bedrijfsinformatiefKcsLL71ObnJliAq5v6MSQV2fGTpSstUPC4mgNg7UbAMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/bedrijfsinformatie.vue?macro=true";
import { default as _91id_93MqwNQvDZUIvLSzkXGjMjuB4JIu5QaRF4T5BlYB_jg7QMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/verantwoordelijken/[id].vue?macro=true";
import { default as indexAihoNQkPAQ6ciXK5qgEfjAmQJAApYGhrkh3cx6YfyzIMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/verantwoordelijken/index.vue?macro=true";
import { default as verantwoordelijkenVGrZf9_27UrsZrOKtN9vRbiTKmdaF9bJeoOeYMRF0cAMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/verantwoordelijken.vue?macro=true";
import { default as newEZI_ZJXWDKVrIjckDv5I_sBKJGZSmcXosts7wDlMbHMMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/new.vue?macro=true";
import { default as indexp5SUWxSCJ_45DoKOQ_45VBHilkNh2gE1dPO86TJDKA_kPO4Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/index.vue?macro=true";
import { default as editmeXOHLQYvvpgcChOcczyp7P39EomQT_tacyOs0jPgL8Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/edit.vue?macro=true";
import { default as indexoraAgrhVXrwCTahfm1A_45_45svlvDK47Z_45NJe_45IzKskaIMMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/index.vue?macro=true";
import { default as _91accidentId_93milpv4INm9tt55kUPCvqJqEzkPWfsQE22kGcQcHWXwgMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/[accidentId].vue?macro=true";
import { default as achtergrondinformatiel4DVP9f5GQMwSBTHJR6OW_UELFLJ29ogQ9bpA0QEsAMMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/achtergrondinformatie.vue?macro=true";
import { default as ongevallenregistratie61OhluTvIEk42Oth3tfOBiqYE_KUJiPgT4IJipQzN4AMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie.vue?macro=true";
import { default as _91companyId_93vB4u0xEfIiUVhs3KaBGpP04lctoD2r6nR6AjHP94VJUMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId].vue?macro=true";
import { default as request_45linktadhE8NAQEVBR_45EOvFs53tAJeEyh9ctPTO9uVWGT5uAMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/request-link.vue?macro=true";
import { default as newTyL2DetSZYwDyTPq6mEdWFKo6JnHbJOrRajckEl__45ZIMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/companies/new.vue?macro=true";
import { default as manage_45catalogzLnA1lr8GYLBL_ow_JMfwylbSQoqcyUVGOBY429_cZ0Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/manage-catalog.vue?macro=true";
import { default as index6CayHyxOqxqPa3nJ70pyWDUJSqpfSL_45Z7_45U17YeQU2AMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/companies/index.vue?macro=true";
import { default as editWc9Z5wH_45_8tb46U63gKWgHGuDvhogI6Z00UJLpLSbbUMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/persoonsgegevens/edit.vue?macro=true";
import { default as indexA94fY9mp8OgHnaUbg8IFe5qjMboHmTPyTWTojoKnxbcMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/persoonsgegevens/index.vue?macro=true";
import { default as persoonsgegevensSYGvt8qt4pjFj5kotQkj_AE4vXiXGACR_45IACH0fYeX8Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/persoonsgegevens.vue?macro=true";
import { default as vragenlijstj9P5AAO5BpYjzCugIJUiCkwH0ortg9z__45e3ianppIogMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/stigas/vragenlijst.vue?macro=true";
import { default as voorwaarden_45afgewezenmtYAghpOG3OaPjuCoRoIzDuILIy1FlCoDn0RQtcagYYMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/voorwaarden-afgewezen.vue?macro=true";
import { default as indexVoGmE8bIsQHXmFuK70XGr0W3ddS7gs1pNnhOkaDT4K4Meta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/application-users/index.vue?macro=true";
import { default as _91userId_93VsDsaFf6W2vbkJdPyyEQhFWoo_45HoTnehtUlCcV_oWIUMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/application-users/[userId].vue?macro=true";
import { default as uitnodigen5d278JMxPwm1jWcttvs1pRJmG0qz8mmSVywAlOQa88QMeta } from "/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/application-users/uitnodigen.vue?macro=true";
export default [
  {
    name: helpBMXUzVwJ1Sh_45syr6mZavTM5x_A8ZTsSJk_gMFOWNkT8Meta?.name ?? "help",
    path: "/help",
    meta: helpBMXUzVwJ1Sh_45syr6mZavTM5x_A8ZTsSJk_gMFOWNkT8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/help.vue")
  },
  {
    name: indexCWUPTmnntzJVCrvbb91u5ZhaIIQfde7P5KDjAF8vZXMMeta?.name ?? "index",
    path: "/",
    meta: indexCWUPTmnntzJVCrvbb91u5ZhaIIQfde7P5KDjAF8vZXMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/index.vue")
  },
  {
    name: loginZY81Li9kRUYcO_45ZMVeUNW1Gt5Cdf79hhw1zQXO_45P2nIMeta?.name ?? "login",
    path: "/login",
    meta: loginZY81Li9kRUYcO_45ZMVeUNW1Gt5Cdf79hhw1zQXO_45P2nIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/login.vue")
  },
  {
    name: logoutbgVLGDCMiSUF3inGTrB7MbTv6Je_TlDOczk_45TVryjTQMeta?.name ?? "logout",
    path: "/logout",
    meta: logoutbgVLGDCMiSUF3inGTrB7MbTv6Je_TlDOczk_45TVryjTQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/logout.vue")
  },
  {
    name: privacyoPZxU3LcIk55WyLWwgKkVovH2wEDMXggc6oVDkxIoUgMeta?.name ?? "privacy",
    path: "/privacy",
    meta: privacyoPZxU3LcIk55WyLWwgKkVovH2wEDMXggc6oVDkxIoUgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/privacy.vue")
  },
  {
    name: _91companyId_93vB4u0xEfIiUVhs3KaBGpP04lctoD2r6nR6AjHP94VJUMeta?.name,
    path: "/:companyId()",
    meta: _91companyId_93vB4u0xEfIiUVhs3KaBGpP04lctoD2r6nR6AjHP94VJUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId].vue"),
    children: [
  {
    name: rieJt5rxvpqlY4cHVOa3jpPlW_45_pAQcFC8lxils5g6fJ0sMeta?.name,
    path: "rie",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie.vue"),
    children: [
  {
    name: newWo3cZb0UgpsrHzwhe9OAAXL4ldRN53ulUYXSSLSWfK4Meta?.name ?? "companyId-rie-new",
    path: "new",
    meta: newWo3cZb0UgpsrHzwhe9OAAXL4ldRN53ulUYXSSLSWfK4Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie/new.vue")
  },
  {
    name: indexKrtqz_45p_45xWrqeHle9KJY711sEIXTAFv4HCMWv8Idu6cMeta?.name ?? "companyId-rie",
    path: "",
    meta: indexKrtqz_45p_45xWrqeHle9KJY711sEIXTAFv4HCMWv8Idu6cMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie/index.vue")
  },
  {
    name: editUiCTkKwcuEvq5BtXpXowhGUNa79CE2v_45fx_HSSobsAUMeta?.name ?? "companyId-rie-rieId-edit",
    path: ":rieId()/edit",
    meta: editUiCTkKwcuEvq5BtXpXowhGUNa79CE2v_45fx_HSSobsAUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie/[rieId]/edit.vue")
  },
  {
    name: indexBKLJ5CgIJVAYHTJNtJX3Q4UdWQJC__S7AtzOcHr_sokMeta?.name ?? "companyId-rie-rieId",
    path: ":rieId()",
    meta: indexBKLJ5CgIJVAYHTJNtJX3Q4UdWQJC__S7AtzOcHr_sokMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/rie/[rieId]/index.vue")
  }
]
  },
  {
    name: indexiInSGaZkteFjW62YBBcqoaBz0BoCeJ59EM1UShgnBPMMeta?.name ?? "companyId",
    path: "",
    meta: indexiInSGaZkteFjW62YBBcqoaBz0BoCeJ59EM1UShgnBPMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/index.vue")
  },
  {
    name: "companyId-rieId",
    path: ":rieId()",
    meta: _91rieId_93a4R10rXVgpuzcrJnrFqTNi3ECV5vKrjO6hnHANmd5UUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId].vue"),
    children: [
  {
    name: risicosQ05J51W5PzrSqo9r_45hMNa98hOHh2fNzmPiLiyTb_45G_IMeta?.name,
    path: "risicos",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/risicos.vue"),
    children: [
  {
    name: indexk5krPrPi_Xfcm_45aQImUR7BkN6e8pBBFvJ3QK3MvbIawMeta?.name ?? "companyId-rieId-risicos",
    path: "",
    meta: indexk5krPrPi_Xfcm_45aQImUR7BkN6e8pBBFvJ3QK3MvbIawMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/risicos/index.vue")
  },
  {
    name: editEfxevWEeCvG4x59xX1_GSu9ObajSxMcbrJ2CBnUrG6QMeta?.name ?? "companyId-rieId-risicos-riskId-edit",
    path: ":riskId()/edit",
    meta: editEfxevWEeCvG4x59xX1_GSu9ObajSxMcbrJ2CBnUrG6QMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/edit.vue")
  },
  {
    name: index_45_VCHVZfUP5XBQbzc7K9FjWBfPf9kDgdThE26flqQegMeta?.name ?? "companyId-rieId-risicos-riskId",
    path: ":riskId()",
    meta: index_45_VCHVZfUP5XBQbzc7K9FjWBfPf9kDgdThE26flqQegMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/index.vue")
  }
]
  },
  {
    name: dashboardfcoXFtsbncQDZj8p__45oPZLHxYqqlBOK7DV_rKmbfxpYMeta?.name ?? "companyId-rieId-dashboard",
    path: "dashboard",
    meta: dashboardfcoXFtsbncQDZj8p__45oPZLHxYqqlBOK7DV_rKmbfxpYMeta || {},
    alias: ["","dashboard"],
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/dashboard.vue")
  },
  {
    name: rapportageJRrkliNTLWfTk62fS9CLavsSALAy98Ex5cWa9esV0jEMeta?.name,
    path: "rapportage",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/rapportage.vue"),
    children: [
  {
    name: index0aUCjajHFxmmmw79fFH_455QxtdfJRsulnB518VIcVR68Meta?.name ?? "companyId-rieId-rapportage",
    path: "",
    meta: index0aUCjajHFxmmmw79fFH_455QxtdfJRsulnB518VIcVR68Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/rapportage/index.vue")
  },
  {
    name: aanmakenwXZSyMpRPOEp5VUM7UxN2TzWnEsPqMfjUrXjUew2YpUMeta?.name ?? "companyId-rieId-rapportage-aanmaken",
    path: "aanmaken",
    meta: aanmakenwXZSyMpRPOEp5VUM7UxN2TzWnEsPqMfjUrXjUew2YpUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/rapportage/aanmaken.vue")
  }
]
  },
  {
    name: inventarisatieFGNLr9sfI8H4kXEZT7y5CgYvxW2O6bwkk6BR45Gd3B0Meta?.name,
    path: "inventarisatie",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie.vue"),
    children: [
  {
    name: indexKgOntLY_45zuE5KAh3T5EM62nb7_45pYR5O0_45Xek3d49BnAMeta?.name ?? "companyId-rieId-inventarisatie",
    path: "",
    meta: indexKgOntLY_45zuE5KAh3T5EM62nb7_45pYR5O0_45Xek3d49BnAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/index.vue")
  },
  {
    name: onderwerpenZXk0Ilq9M4cirCDEh3Q1Xt7o99JfiSlIiY_0yPAY3LkMeta?.name ?? "companyId-rieId-inventarisatie-onderwerpen",
    path: "onderwerpen",
    meta: onderwerpenZXk0Ilq9M4cirCDEh3Q1Xt7o99JfiSlIiY_0yPAY3LkMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/onderwerpen.vue")
  },
  {
    name: endwWV_45y9KPFLi6NJ7U_ZiYvxaeiM8NrOwZ6Yl8evhcqzsMeta?.name ?? "companyId-rieId-inventarisatie-topicKey-end",
    path: ":topicKey()/end",
    meta: endwWV_45y9KPFLi6NJ7U_ZiYvxaeiM8NrOwZ6Yl8evhcqzsMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/end.vue")
  },
  {
    name: indexAIhJKU8g3HQ7WEoH8VDmwj_45YqSxCRtWQ28_45qJiym9qsMeta?.name ?? "companyId-rieId-inventarisatie-topicKey",
    path: ":topicKey()",
    meta: indexAIhJKU8g3HQ7WEoH8VDmwj_45YqSxCRtWQ28_45qJiym9qsMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/index.vue")
  },
  {
    name: _91questionKey_93iUVwEI2XAm6DYZI00RtouTImw2eqKEcD7gm1znlcVa8Meta?.name ?? "companyId-rieId-inventarisatie-topicKey-questionKey",
    path: ":topicKey()/:questionKey()",
    meta: _91questionKey_93iUVwEI2XAm6DYZI00RtouTImw2eqKEcD7gm1znlcVa8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/[questionKey].vue")
  }
]
  },
  {
    name: plan_45van_45aanpakEjr8CMyTHPCgqIzhxCp35EWMy88FymUrVdOYF0IBXWIMeta?.name,
    path: "plan-van-aanpak",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/plan-van-aanpak.vue"),
    children: [
  {
    name: index8_5IKtH5XZiqirEDRgZMMTKIS7D9wqovbC33Wj70PcgMeta?.name ?? "companyId-rieId-plan-van-aanpak",
    path: "",
    meta: index8_5IKtH5XZiqirEDRgZMMTKIS7D9wqovbC33Wj70PcgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/index.vue")
  },
  {
    name: editl6aHvvg_IOV4uiT7iD0diHpquPUh_45v6T9yHEhlYwvaIMeta?.name ?? "companyId-rieId-plan-van-aanpak-actionId-edit",
    path: ":actionId()/edit",
    meta: editl6aHvvg_IOV4uiT7iD0diHpquPUh_45v6T9yHEhlYwvaIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/edit.vue")
  },
  {
    name: indexC6n9i5tO4ptS_VQaS8V_45N0_45Ry3mLWDddoLsBl9W6ia0Meta?.name ?? "companyId-rieId-plan-van-aanpak-actionId",
    path: ":actionId()",
    meta: indexC6n9i5tO4ptS_VQaS8V_45N0_45Ry3mLWDddoLsBl9W6ia0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/index.vue")
  }
]
  },
  {
    name: indexIIbjB2QYgvX0oE7MDI6IdPofog4DA1apnj4c7V66kzIMeta?.name ?? "companyId-rieId-stigas-werknemersvragenlijst",
    path: "stigas/werknemersvragenlijst",
    meta: indexIIbjB2QYgvX0oE7MDI6IdPofog4DA1apnj4c7V66kzIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/[rieId]/stigas/werknemersvragenlijst/index.vue")
  }
]
  },
  {
    name: gebruikersH69QcoDW6n4rsquVPfPSo25glJf3eQq7c2IBIjCyQ6IMeta?.name,
    path: "gebruikers",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/gebruikers.vue"),
    children: [
  {
    name: index_uVds1HPwW0LAD8dfn3hoTijR4TmrRtFwg9TMR_45iBu0Meta?.name ?? "companyId-gebruikers",
    path: "",
    meta: index_uVds1HPwW0LAD8dfn3hoTijR4TmrRtFwg9TMR_45iBu0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/gebruikers/index.vue")
  },
  {
    name: _91userId_931XfMkABcobM3aVFfT5IgH6U0pka8MJI1UwZw0L9VKFUMeta?.name ?? "companyId-gebruikers-userId",
    path: ":userId()",
    meta: _91userId_931XfMkABcobM3aVFfT5IgH6U0pka8MJI1UwZw0L9VKFUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/gebruikers/[userId].vue")
  },
  {
    name: uitnodigeno2UiWBu2ngbC1zBIIXSuvfrG7znRsLc4IcGw6tNrUIMMeta?.name ?? "companyId-gebruikers-uitnodigen",
    path: "uitnodigen",
    meta: uitnodigeno2UiWBu2ngbC1zBIIXSuvfrG7znRsLc4IcGw6tNrUIMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/gebruikers/uitnodigen.vue")
  }
]
  },
  {
    name: bedrijfsinformatiefKcsLL71ObnJliAq5v6MSQV2fGTpSstUPC4mgNg7UbAMeta?.name,
    path: "bedrijfsinformatie",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/bedrijfsinformatie.vue"),
    children: [
  {
    name: editXwy99iCGOLMKLu_45o1JXpY1Cnr3PRX_A4e0dkHhLltV4Meta?.name ?? "companyId-bedrijfsinformatie-edit",
    path: "edit",
    meta: editXwy99iCGOLMKLu_45o1JXpY1Cnr3PRX_A4e0dkHhLltV4Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/bedrijfsinformatie/edit.vue")
  },
  {
    name: indexQD55RlJJB6ucYu6bjS_45rsxHphWKyDgcHd4OV_452qFVIwMeta?.name ?? "companyId-bedrijfsinformatie",
    path: "",
    meta: indexQD55RlJJB6ucYu6bjS_45rsxHphWKyDgcHd4OV_452qFVIwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/bedrijfsinformatie/index.vue")
  }
]
  },
  {
    name: verantwoordelijkenVGrZf9_27UrsZrOKtN9vRbiTKmdaF9bJeoOeYMRF0cAMeta?.name,
    path: "verantwoordelijken",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/verantwoordelijken.vue"),
    children: [
  {
    name: _91id_93MqwNQvDZUIvLSzkXGjMjuB4JIu5QaRF4T5BlYB_jg7QMeta?.name ?? "companyId-verantwoordelijken-id",
    path: ":id()",
    meta: _91id_93MqwNQvDZUIvLSzkXGjMjuB4JIu5QaRF4T5BlYB_jg7QMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/verantwoordelijken/[id].vue")
  },
  {
    name: indexAihoNQkPAQ6ciXK5qgEfjAmQJAApYGhrkh3cx6YfyzIMeta?.name ?? "companyId-verantwoordelijken",
    path: "",
    meta: indexAihoNQkPAQ6ciXK5qgEfjAmQJAApYGhrkh3cx6YfyzIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/verantwoordelijken/index.vue")
  }
]
  },
  {
    name: ongevallenregistratie61OhluTvIEk42Oth3tfOBiqYE_KUJiPgT4IJipQzN4AMeta?.name,
    path: "ongevallenregistratie",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie.vue"),
    children: [
  {
    name: newEZI_ZJXWDKVrIjckDv5I_sBKJGZSmcXosts7wDlMbHMMeta?.name ?? "companyId-ongevallenregistratie-new",
    path: "new",
    meta: newEZI_ZJXWDKVrIjckDv5I_sBKJGZSmcXosts7wDlMbHMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/new.vue")
  },
  {
    name: indexp5SUWxSCJ_45DoKOQ_45VBHilkNh2gE1dPO86TJDKA_kPO4Meta?.name ?? "companyId-ongevallenregistratie",
    path: "",
    meta: indexp5SUWxSCJ_45DoKOQ_45VBHilkNh2gE1dPO86TJDKA_kPO4Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/index.vue")
  },
  {
    name: _91accidentId_93milpv4INm9tt55kUPCvqJqEzkPWfsQE22kGcQcHWXwgMeta?.name,
    path: ":accidentId()",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/[accidentId].vue"),
    children: [
  {
    name: editmeXOHLQYvvpgcChOcczyp7P39EomQT_tacyOs0jPgL8Meta?.name ?? "companyId-ongevallenregistratie-accidentId-edit",
    path: "edit",
    meta: editmeXOHLQYvvpgcChOcczyp7P39EomQT_tacyOs0jPgL8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/edit.vue")
  },
  {
    name: indexoraAgrhVXrwCTahfm1A_45_45svlvDK47Z_45NJe_45IzKskaIMMeta?.name ?? "companyId-ongevallenregistratie-accidentId",
    path: "",
    meta: indexoraAgrhVXrwCTahfm1A_45_45svlvDK47Z_45NJe_45IzKskaIMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/index.vue")
  }
]
  },
  {
    name: achtergrondinformatiel4DVP9f5GQMwSBTHJR6OW_UELFLJ29ogQ9bpA0QEsAMMeta?.name ?? "companyId-ongevallenregistratie-achtergrondinformatie",
    path: "achtergrondinformatie",
    meta: achtergrondinformatiel4DVP9f5GQMwSBTHJR6OW_UELFLJ29ogQ9bpA0QEsAMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/[companyId]/ongevallenregistratie/achtergrondinformatie.vue")
  }
]
  }
]
  },
  {
    name: request_45linktadhE8NAQEVBR_45EOvFs53tAJeEyh9ctPTO9uVWGT5uAMeta?.name ?? "request-link",
    path: "/request-link",
    meta: request_45linktadhE8NAQEVBR_45EOvFs53tAJeEyh9ctPTO9uVWGT5uAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/request-link.vue")
  },
  {
    name: newTyL2DetSZYwDyTPq6mEdWFKo6JnHbJOrRajckEl__45ZIMeta?.name ?? "companies-new",
    path: "/companies/new",
    meta: newTyL2DetSZYwDyTPq6mEdWFKo6JnHbJOrRajckEl__45ZIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/companies/new.vue")
  },
  {
    name: manage_45catalogzLnA1lr8GYLBL_ow_JMfwylbSQoqcyUVGOBY429_cZ0Meta?.name ?? "manage-catalog",
    path: "/manage-catalog",
    meta: manage_45catalogzLnA1lr8GYLBL_ow_JMfwylbSQoqcyUVGOBY429_cZ0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/manage-catalog.vue")
  },
  {
    name: index6CayHyxOqxqPa3nJ70pyWDUJSqpfSL_45Z7_45U17YeQU2AMeta?.name ?? "companies",
    path: "/companies",
    meta: index6CayHyxOqxqPa3nJ70pyWDUJSqpfSL_45Z7_45U17YeQU2AMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/companies/index.vue")
  },
  {
    name: persoonsgegevensSYGvt8qt4pjFj5kotQkj_AE4vXiXGACR_45IACH0fYeX8Meta?.name,
    path: "/persoonsgegevens",
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/persoonsgegevens.vue"),
    children: [
  {
    name: editWc9Z5wH_45_8tb46U63gKWgHGuDvhogI6Z00UJLpLSbbUMeta?.name ?? "persoonsgegevens-edit",
    path: "edit",
    meta: editWc9Z5wH_45_8tb46U63gKWgHGuDvhogI6Z00UJLpLSbbUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/persoonsgegevens/edit.vue")
  },
  {
    name: indexA94fY9mp8OgHnaUbg8IFe5qjMboHmTPyTWTojoKnxbcMeta?.name ?? "persoonsgegevens",
    path: "",
    meta: indexA94fY9mp8OgHnaUbg8IFe5qjMboHmTPyTWTojoKnxbcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/persoonsgegevens/index.vue")
  }
]
  },
  {
    name: vragenlijstj9P5AAO5BpYjzCugIJUiCkwH0ortg9z__45e3ianppIogMeta?.name ?? "stigas-vragenlijst",
    path: "/stigas/vragenlijst",
    meta: vragenlijstj9P5AAO5BpYjzCugIJUiCkwH0ortg9z__45e3ianppIogMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/stigas/vragenlijst.vue")
  },
  {
    name: voorwaarden_45afgewezenmtYAghpOG3OaPjuCoRoIzDuILIy1FlCoDn0RQtcagYYMeta?.name ?? "voorwaarden-afgewezen",
    path: "/voorwaarden-afgewezen",
    meta: voorwaarden_45afgewezenmtYAghpOG3OaPjuCoRoIzDuILIy1FlCoDn0RQtcagYYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/voorwaarden-afgewezen.vue")
  },
  {
    name: indexVoGmE8bIsQHXmFuK70XGr0W3ddS7gs1pNnhOkaDT4K4Meta?.name ?? "application-users",
    path: "/application-users",
    meta: indexVoGmE8bIsQHXmFuK70XGr0W3ddS7gs1pNnhOkaDT4K4Meta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/application-users/index.vue")
  },
  {
    name: _91userId_93VsDsaFf6W2vbkJdPyyEQhFWoo_45HoTnehtUlCcV_oWIUMeta?.name ?? "application-users-userId",
    path: "/application-users/:userId()",
    meta: _91userId_93VsDsaFf6W2vbkJdPyyEQhFWoo_45HoTnehtUlCcV_oWIUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/application-users/[userId].vue")
  },
  {
    name: uitnodigen5d278JMxPwm1jWcttvs1pRJmG0qz8mmSVywAlOQa88QMeta?.name ?? "application-users-uitnodigen",
    path: "/application-users/uitnodigen",
    meta: uitnodigen5d278JMxPwm1jWcttvs1pRJmG0qz8mmSVywAlOQa88QMeta || {},
    component: () => import("/var/lib/jenkins/workspace/78-Spring-boot-3.5.3-terugzetten/frontend/pages/application-users/uitnodigen.vue")
  }
]